import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Portfolio from "@/pages/Portfolio";
import CustomCursor from "@/components/CustomCursor";
import Grain from "@/components/Grain";
import useLenis from "@/hooks/useLenis";

function App() {
  useLenis();
  return (
    <div className="App" data-testid="app-root">
      <Grain />
      <CustomCursor />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portfolio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
